<template>
  <div class="resetPassword xi">
    <nh-com></nh-com>
    <!-- <div class="banner">
            <div class="banner-wrap clearfix">
                <div class="banner-text">
                    <h3>个人中心</h3>
                    <p>当前位置：
                        <router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>个人中心</a>
                    </p>
                </div>
            </div>
        </div> -->
    <div class="startBtnBox">
        <div class="startBtnBoxImg">
          <img src="@/assets/img/queImg/bblz.png" mode="" />
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between; width: 600px;margin: auto;" >
          <div class="startBtnL" @click="goText">测试记录</div>
           <div class="startBtn" @click="goStart">开始问诊</div>
        </div>
   
      <!-- <div class="startBtnBoxFlex">

        <div class="startBtnBoxRight flex-space-around-columns">
          <div class="" style="font-size: 24px; text-align: center; font-weight: bold">中医辨病论治</div>
          <div class="" style="margin-top: 10px">辨病论治是中医诊疗疾病的一种基本方法，即根据不同疾病的各自特征，作出相应的疾病诊断，并针对不同疾病，进行相应的或特异的治疗。</div>
          <div class="" style="margin-top: 10px">一种具体的病往往具有特定的病因、病机和症状，因而显示其特异性，并反映在病因作用和正虚邪凑的条件下，体内出现一定发展规律的邪正交争、阴阳失调的全部演变过程。因此，辨病论治可以把握疾病的基本矛盾变化，有利于从疾病的全局考虑其治疗方法，而且还能采用某些特异性治法和方药，进行特异性治疗。</div>
          <div class="" style="margin-top: 10px;color:red"> <i class="el-icon-warning-outline" style="margin-right:5px"></i>本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成</div>
          <div class="startBtn" @click="goStart">开始问诊</div>
        </div>
      </div> -->
    </div>
    <ft-com></ft-com>
    <UpgradeMsgBox ref="upgradeMsgBox" @currentlyAvailable="getCurrentlyAvailable" :fullPath="$router.currentRoute.fullPath"></UpgradeMsgBox>
  </div>
</template>
<script>
import ftCom from "../../components/footerNew";
import nhCom from "../../components/header";

export default {
  name: "resetPassword",
  components: {
    ftCom,
    nhCom,
  },
  data() {
    return {
      labelPosition: "right",
      resetPassword: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: "",
      },
      uploader: null,
      file: "",
      patientType: 1, // 固定值
      organitionId: 0, // 固定值
      keyWord: "",
      pageIndex: 1,
      userInfo: {},
      patientList: [],
      visible: false,
      currentlyAvailable: false,
    };
  },
  methods: {
    getCurrentlyAvailable(data) {
      this.currentlyAvailable = data;
    },
    goStart() {
      if (!this.currentlyAvailable) {
        this.$refs.upgradeMsgBox.openTip();
        return;
      }
      this.$router.push("./diseaseStart");
    },
    goText(){
      this.$router.push("./diseaseTestList");
    },
    getList() {
      var _this = this;
      _this.userInfo = this.$store.state.localData.userInfo;
      console.log(_this.keyWord);
      _this.patientDomain.getPatientList(
        this.patientType,
        _this.userInfo.organizationId,
        _this.userInfo.id,
        "",
        "",
        _this.keyWord,
        _this.pageIndex,
        function (data) {
          _this.patientList = data.data.results;
          for (var i = 0; i < _this.patientList.length; i++) {
            var f = _this.patientList[i].addTime.split("T");
            _this.patientList[i].addTime = f[0] + " " + f[1].slice(0, 8);
          }
        },
        function (error) {
          console.log(error);
        }
      );
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

.startBtnBox {
  /* width: 60%; */
   background: linear-gradient(180deg, #FFEFDE 0%, #F5F5F5 50%);
  /* border-radius: 19px; */
  padding: 30px;
  /* margin-top: 60px; */
  /* margin-left: 20%; */
  /* margin-bottom: 60px; */
}
.startBtnL {
  color: #ffffff;
  padding: 10px 0;
  text-align: center;
  width: 200px;
  font-size: 24px;
  cursor: pointer;
  border: 1px solid #FFB6A6;
  font-size: 24px;
  color: #FF6846;
  border-radius: 10px;
  margin-top:30px;
  margin-bottom:90px
}
.startBtn {
  color: #ffffff;
  padding: 10px 0;
  text-align: center;
  width: 350px;
  font-size: 24px;
  cursor: pointer;
  background: linear-gradient(270deg, #E89948, #F2B676);
  border-radius: 10px;
  margin-top:30px;
  margin-bottom:90px
}
.startBtnBoxImg {
  width: 640px;
  height: 658px;
  margin: auto;
 
}
.startBtnBoxImg img {
  width: 100%;
  height: 100%;
}
.startBtnBoxFlex {
  display: flex;
  /* justify-content: space-between; */
}
.startBtnBoxRight {
  width: calc(80% - 380px);
  background: #ffffff;
  border-radius: 48px;
  padding: 40px;
  position: relative;
  margin-left: 50px;
}
</style>
<style>
.personal-center {
  display: none;
}
</style>
